import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {
  AbstractProdGrid,
  FormEvent,
  IProdGrid,
  ProdGridColumnTransforms,
  ProdGridColumnType,
  RequestEvent,
  ResponseEvent
} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from "prod-shared";
import {take} from "rxjs";
import {Role} from "../../../dip/role";
import {RoleService} from "../../../services/role.service";
import {UserService} from "../../../services/user.service";
import {UserGroupService} from "../../../services/user-group.service";
import {OrganizationTreeSelect} from "../../../dip/organization-tree-select";
import {DipColumn} from "../../../dip/dip-column";
import {DistributorUserFormComponent} from "./distributor-user-form/distributor-user-form.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-distributor-user',
  templateUrl: './distributor-user.component.html'
})
export class DistributorUserComponent extends AbstractProdGrid implements IProdGrid {
  @Input() distributor: number = null;
  prodGridTitle: string = this.translate.instant('distributor.users.grid_title');
  prodGridToolbarButtonsStatus = {
    isAddButtonDisabled: {
      role: [Role.ROLE_DISTRIBUTOR_ADMIN],
      disabled: !this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN])
    },
    isRemoveButtonDisabled: {
      role: [Role.ROLE_DISTRIBUTOR_ADMIN],
      disabled: !this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN])
    }
  };
  override prodGridForm = {
    component: DistributorUserFormComponent,
    style: {height: '60%', width: '65%'},
    editStyle: {height: '60%', width: '65%'},
    extraData: {distributor: null}
  };
  prodGridColumns: DipColumn[] = [
    DipColumn.get({
      property: 'username', type: ProdGridColumnType.SELECT_COMPONENT,
      selectParameters: {
        selectDataService: UserService,
        isMulti: true,
        isNarrowDown: true,
        isComplete: true,
      },
      isSelfFilter: true
    }),
    DipColumn.get({property: 'firstName', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'lastName', type: ProdGridColumnType.STRING}),
    DipColumn.get({
      property: 'groups',
      type: ProdGridColumnType.SELECT_COMPONENT,
      transform: {
        transform: ProdGridColumnTransforms.ARRAY_JOIN,
        option: 'name'
      },
      sortable: false,
      selectParameters: {
        selectDataService: UserGroupService,
        isComplete: true,
        isNarrowDown: true,
        isMulti: true
      }
    }),
    DipColumn.get({
      property: 'lastLogin',
      type: ProdGridColumnType.DATE,
      transform: {
        transform: ProdGridColumnTransforms.DATETIME
      }
    })
  ];

  constructor(protected override changeDetectorRef: ChangeDetectorRef,
              override prodGridDataService: UserService,
              private organizationTreeSelect: OrganizationTreeSelect,
              private roleService: RoleService,
              private translate: TranslateService) {
    super(changeDetectorRef);
    organizationTreeSelect.gridComponent = this;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.prodGridForm.extraData.distributor = this.distributor;
  }

  ngOnDestroy() {
    this.organizationTreeSelect.gridComponent = null;
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    return super.loadProdGridData(HttpExtraParams.addFilter(httpExtraParams, new HttpFilterParam({
      property: 'groups.organizationUserGroup.organization',
      operator: 'eq',
      value: this.distributor
    })));
  }

  //todo serviceben átírni
  override outputActionEvents(event: { event: RequestEvent | ResponseEvent, value?: any }) {
    if (event.event === RequestEvent.REQUEST_REMOVE) {
      let deletedCount = event.value.getSize();
      event.value.getAll().forEach(record => {
        this.prodGridDataService.distributorGridRemove(record.id, this.distributor)
          .pipe(take(1)).subscribe(response => {
          deletedCount--;

          if (deletedCount === 0) {
            this.inputAction$.emit(new FormEvent());
          }
        });
      });
      return;
    }
    super.outputActionEvents(event);
  }
}
